import { Component } from '@angular/core';
import { LivePricesComponent } from './live-prices.component';

@Component({
  selector: 'eid-live-prices-mobile',
  templateUrl: './live-prices.mobile.component.html',
  styleUrls: ['./live-prices.mobile.component.scss']
})
export class LivePricesMobileComponent extends LivePricesComponent {}
